import React, { Fragment } from 'react';
import PackageGitEvents from '../../components/package/git-events';
import { TitleBar } from '../../styles/layout/titlebar';
import useTitle from 'hooks/useTitle';
import { Content } from 'styles/globalStyles';
import { useLocation } from 'react-router-dom';
import JsxHelper from 'helpers/jsx';

const ThemeGitEvents = () => {
  useTitle('Theme Events History');

  const { state } = useLocation();
  const breadcrumbs = JsxHelper.createBreadcrumbs('Events History', 'themes');

  return (
    <Fragment>
      <TitleBar>
        <TitleBar.Title breadcrumbs={breadcrumbs}>Theme Events History</TitleBar.Title>
        <TitleBar.Actions>
          {JsxHelper.createBackButton()}
        </TitleBar.Actions>
      </TitleBar>
      <Content>
        <PackageGitEvents currentPackage={state} />
      </Content>
    </Fragment>
  );
};

export default ThemeGitEvents;
